module.exports = __webpack_public_path__ + "static/media/builtinv2-ustranyat oshibku 1.89319e8c.png";